export const LATENCY_ERRORS_EXPORT_ID = "Errores de Latencia";
export const LATENCY_ERRORS_TITLE = "Errores de Latencia";

export const LATENCY_ERRORS_PROPERTIES = {
    documentIdentifier: "Identificador de Documento",
    message: "Mensaje",        
    dataRecievedLatency: "Datos Recibidos",
    dataSentLatency: "Datos Enviados",
    status: "Estado"
};

export const STATUS_OPTIONS = [
  { value: 'P', label: 'En Progreso' },
  { value: 'S', label: 'Exitoso' },
  { value: 'W', label: 'Advertencia' },
  { value: 'E', label: 'Error' },
];